import type {
  Dispatch,
  DispatchAssigned,
  DispatchUnassigned,
} from '@bambi/api-client/schemas';

// the header counts come from /dispatch/summary/, so nothing reads this
const EMPTY_SUMMARY: Dispatch['summary'] = {
  completed: 0,
  will_call: 0,
  canceled: 0,
  on_time: 0,
  delayed: 0,
  assigned: 0,
};

export const combineDispatchHalves = (
  assigned: DispatchAssigned | undefined,
  unassigned: DispatchUnassigned | undefined
): Dispatch | undefined =>
  assigned && unassigned
    ? { ...assigned, ...unassigned, summary: EMPTY_SUMMARY }
    : undefined;
